module.exports = __webpack_public_path__ + "media/images/icon-leader-b2e1203449222e42d948f648270cbd3d.svg";